const _i18n_info = {
  notice: {
    EN: `plz, wait partner or manager review`,
    KO: `plz, wait partner or manager review`,
    JP: `パートナーまたはマネージャーのレビューをお待ちください`
  },
}

const _i18n_success = {
  stop: {
    EN: `request stopping service`,
    KO: `request stopping service`,
    JP: `サービスの停止をリクエストする`
  },
  billing: {
    EN: `A bill has been issued this month.`,
    KO: `A bill has been issued this month.`,
    JP: `今月の請求書が発行されました`
  },
}

const _i18n_warning = {
  ip_check: {
    EN: `no have ip address`,
    KO: `no have ip address`,
    JP: `IPアドレスは存在しません`
  },
  ip_check2: {
    EN: `ip address exist`,
    KO: `ip address exist`,
    JP: `IPアドレスは存在します`
  },
}

const _i18n_error = {
  signout : {
    EN: `Failed to terminate membership`,
    KO: `Failed to terminate membership`,
    JP: `メンバーシップを終了できませんでした`
  },
  status_processing: {
    EN: `STEP.2 resolve first`,
    KO: `STEP.2 resolve first`,
    JP: `STEP.2 まず解決する`
  },
  signout_cancel : {
    EN: `Failed suspension of Services and Requests to Leave`,
    KO: `Failed suspension of Services and Requests to Leave`,
    JP: `サービス停止の失敗と退会依頼`
  },
  signout_stop : {
    EN: `Failed service stop request`,
    KO: `Failed service stop request`,
    JP: `サービス停止要求の失敗`
  },
  ip_check3: {
    EN: `only allow 2 ip address`,
    KO: `only allow 2 ip address`,
    JP: `2つのIPアドレスのみを許可します`
  },
  name_req: {
    EN: `Name required.`,
    KO: `Name required.`,
    JP: `名前は必須です`
  },
  list: {
    EN: `require data for update`,
    KO: `require data for update`,
    JP: `更新にはデータが必要です`
  }
}

const i18n_toast = {
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error
}

export default i18n_toast